module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.$style.root
  }, [_c('box-widget', {
    staticClass: "builder",
    attrs: {
      "icon": "pencil",
      "state": "success",
      "badge": "badge"
    }
  }, [_c('template', {
    slot: "head"
  }, [_vm._v(_vm._s(_vm.$t('pos.campaign.creatives.external_previews.header')))]), _c('template', {
    slot: "content"
  }, [_c('file-upload', {
    staticClass: "text-center",
    attrs: {
      "files": _vm.creative.external_previews,
      "data-externalpreviews-input": "fileupload",
      "data-externalpreviews-files-max": "20",
      "rules": _vm.$t("pos.comment.rules.file-upload")
    },
    on: {
      "update:files": _vm.updateExternalPreviewsFiles
    }
  }), _c('div', {
    staticClass: "save-buttons"
  }, [_c('b-button', {
    staticClass: "save save-btn",
    attrs: {
      "data-externalpreviews-button": "save"
    },
    on: {
      "click": function($event) {
        _vm.save(false)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('pos.campaign.creatives.external_previews.save')))]), (_vm.canFinishCreative) ? _c('b-button', {
    staticClass: "save finish-btn",
    attrs: {
      "data-externalpreviews-button": "finish"
    },
    on: {
      "click": function($event) {
        _vm.save(true)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('pos.campaign.creatives.external_previews.save-finish')))]) : _vm._e()], 1)], 1)], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b82ba146"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/lab/creative-external-previews/CreativeExternalPreviews.vue
// module id = 2087
// module chunks = 1